import { render, staticRenderFns } from "./FormRadioInputComponent.vue?vue&type=template&id=bb084572"
import script from "./FormRadioInputComponent.vue?vue&type=script&lang=js"
export * from "./FormRadioInputComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports